import React from 'react';
import { AddPromptModal } from '@containers/TableAnalysis/tableComponents/AddPromptRow';
import { TransparentFlatButton } from '@ui/buttons';

export const AddPromptCell = () => {
  const [isAddingPrompt, setIsAddingPrompt] = React.useState(false);
  const onDismiss = () => setIsAddingPrompt(false);

  const handleAddQuestionClick = () => {
    setIsAddingPrompt(true);
  };

  return (
    <>
      {isAddingPrompt && <AddPromptModal onDismiss={onDismiss} />}
      <TransparentFlatButton onClick={handleAddQuestionClick}>+ Add Question</TransparentFlatButton>
    </>
  );
};
